import { reactive, computed, ref, handleError } from 'vue';
import { GET, POST, PUT } from '@/packge/http';
import { message } from 'ant-design-vue';
import store from '@/store';

export const avatarBorder = computed(() => {
  let border = '';
  if (!formState.fileUrl && !formState.avatar) {
    border = '1px solid #E9EDF3';
  }
  return border;
});

export const formState = reactive({
  avatar: '',
  nickName: undefined,
  phonenumber: undefined,
  sex: undefined,
  sexDesc: undefined,
  uid: false
});

export const getUserInfo = () => {
  GET({
    url: '/user/getInfo',
    params: {}
  }).then(({ data }) => {
    for (let item in data) {
      if (formState.hasOwnProperty(item)) {
        formState[item] = data[item];
        if (item == 'phonenumber') {
          sessionStorage.phonenumber = data[item];
        }
      }
    }
    cropAvatar();
  });
};

/** 头像裁剪 */
export function cropAvatar () {
  const img = new Image();
  img.src = formState.fileUrl || formState.avatar;
  const obj = {
    backgroundImage: `url(${formState.avatar})`,
    backgroundPosition: 'center'
  };
  img.onload = function () {
    if (img.width > img.height || img.width === img.height) {
      formState.avatarStyle = { ...obj, backgroundSize: 'auto 100%' };
    } else if (img.height > img.width) {
      formState.avatarStyle = { ...obj, backgroundSize: '100% auto' };
    }
  };
  store.commit('setUserInfo', formState);
}

export const bindData = reactive({
  phonenumber: '',
  isBindEmail: '',
  isBindVOS: '',
  bindDeviceCount: '',
  bindAppCount: '',
  bindOtherCount: ''
});

/** 获取用户绑定信息 */
export function getBingInfo () {
  GET({
    url: '/account/bingInfo',
    params: {}
  }).then(({ data }) => {
    for (let item in bindData) {
      bindData[item] = data[item];
    }

    const thirdAccount = data.isBindVOS && data.isBindVOS.filter(item => item.status);
    bindData.isBindVOS = thirdAccount.length ? thirdAccount.length : null;
  });
}

export const onSubmit = (refresh = true, handle = () => {}) => {
  return new Promise((resolve) => {
    let data = { ...formState };
    if (data.avatar.includes('http')) { // 处理没有修改头像直接提交情况
      delete data.avatar;
    }
    data.fileUrl && delete data.fileUrl;
    data.fileId && delete data.fileId;

    handle(data);

    PUT({
      url: '/user',
      params: data
    }).then(({ data }) => {
      message.success('修改成功');
      resolve();
      refresh && getUserInfo();
    });
  });
};

export function triggerInput (event) {
  event.stopPropagation();
  document.getElementById('uploadInput').click();
}

export function uploadAvatar (file) {
  const fileData = file.target.files[0];
  if (!fileData) { return false; } // 选中文件后，点击取消返回 undefined
  let form = new FormData();
  form.set('file', file.target.files[0]);
  POST({
    url: '/user/uploadAvatar',
    params: form
  }).then(({ data }) => {
    formState.fileId = data.fileId;
    formState.avatar = data.fileId;
    formState.fileUrl = data.fileUrl;
    onSubmit();
  });
}
